import { SpinnerInline } from "./Spinner";

export default function Button({ children, className = "", loading = false, ...props }) {
  return (
    <button
      className={
        "inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-sm transition border " +
        "bg-[rgb(var(--primary))] text-white border-transparent " +
        "hover:opacity-90 active:opacity-80 disabled:opacity-60 disabled:cursor-not-allowed " +
        className
      }
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && <SpinnerInline />}
      {children}
    </button>
  );
}